export default "//file.bilionpass.com/japandx-portal/0.1.23/static/img/ceo-quote-close.3cb64f7a-dc42b7.svg";